import { useMemo } from "react"
import { graphql, useStaticQuery } from "gatsby"

export type MarketplaceSitemapQuery = {
  flatData: {
    name: string
    pages: {
      status: string
      flatData: {
        url: string
      }
    }[]
    primaryCategory: {
      flatData: {
        name: string
        pages: {
          flatData: {
            url: string
          }
        }
      }
    }
  }
}

type Query = {
  GraphCmsSquidex: {
    queryMarketplaceProductContents: MarketplaceSitemapQuery[]
  }
}

export default function useMarketplaceSitemapQuery(): MarketplaceSitemapQuery[] {
  const {
    GraphCmsSquidex: { queryMarketplaceProductContents },
  } = useStaticQuery<Query>(graphql`
    {
      GraphCmsSquidex {
        queryMarketplaceProductContents(
          top: 1000
          orderby: "data/name/iv asc"
        ) {
          flatData {
            name
            pages {
              status
              flatData {
                url
              }
            }
            primaryCategory {
              flatData {
                name
                pages {
                  flatData {
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  return useMemo(
    () =>
      queryMarketplaceProductContents.filter(
        (product) => product.flatData.pages && product.flatData.pages.length > 0
      ),
    [queryMarketplaceProductContents]
  )
}
